import React from 'react'
import { createBrowserRouter } from 'react-router'
import { RootLayout } from './layout/RootLayout'
import { MainLayout } from './layout/MainLayout'
import { OnboardingPage, onboardingPagePath } from './pages/OnboardingPage'
import {
  ProfilePage,
  profileVotesPagePath,
  profileMyBoxesPagePath,
  ProfileBoxTypeTab,
} from './pages/ProfilePage'
import {
  CreateMoneyPoolPage,
  createMoneyPoolPagePath,
} from './pages/CreateMoneyPoolPage'
import {
  BoxCreateSuccessPage,
  boxCreateSuccessPagePath,
} from './pages/BoxCreateSuccessPage'
import {
  IndexPage,
  indexPagePath,
  indexMyPagePath,
  indexMyVotesPagePath,
  indexFinishedPagePath,
} from './pages/IndexPage'
import { SingleBoxPage, singleBoxPagePath } from './pages/SingleBoxPage'
import {
  BonusPage,
  bonusTasksPagePath,
  bonusReferralsPagePath,
  BonusTab,
} from './pages/BonusPage'
import { FaqPage, faqPagePath } from './pages/FaqPage'
import { LanguagePage, languagePagePath } from './pages/LanguagePage'
import { VersionPage, versionPagePath } from './pages/VersionPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { APP_NAME } from './constants'

export const createRouter = (basePath: string) =>
  createBrowserRouter(
    [
      {
        element: <RootLayout />,
        children: [
          {
            path: onboardingPagePath,
            element: <OnboardingPage />,
          },
          {
            element: <MainLayout headerMode="full" isShowBottomNavigation />,
            children: [
              {
                path: profileVotesPagePath,
                element: <ProfilePage activeTab={ProfileBoxTypeTab.Votes} />,
              },
              {
                path: profileMyBoxesPagePath,
                element: <ProfilePage activeTab={ProfileBoxTypeTab.MyBoxes} />,
              },
            ],
          },
          {
            element: (
              <MainLayout headerMode="with-logo" isShowBottomNavigation />
            ),
            children: [
              {
                path: createMoneyPoolPagePath,
                element: <CreateMoneyPoolPage />,
              },
              {
                path: boxCreateSuccessPagePath,
                element: <BoxCreateSuccessPage />,
              },
            ],
          },
          {
            element: (
              <MainLayout headerMode="with-logo" isShowBottomNavigation />
            ),
            children: [
              {
                index: true,
                path: indexPagePath,
                element: <IndexPage activeTag="all" />,
              },
              {
                path: indexMyPagePath,
                element: <IndexPage activeTag="my" />,
              },
              {
                path: indexMyVotesPagePath,
                element: <IndexPage activeTag="my-votes" />,
              },
              {
                path: indexFinishedPagePath,
                element: <IndexPage activeTag="finished" />,
              },
              {
                path: `${indexPagePath}/${APP_NAME}`,
                element: <IndexPage activeTag="all" />,
              },
            ],
          },
          {
            element: (
              <MainLayout headerMode="with-logo" isShowBottomNavigation />
            ),
            children: [
              {
                path: singleBoxPagePath,
                element: <SingleBoxPage />,
              },
              {
                path: bonusTasksPagePath,
                element: <BonusPage activeTab={BonusTab.Tasks} />,
              },
              {
                path: bonusReferralsPagePath,
                element: <BonusPage activeTab={BonusTab.Referrals} />,
              },
              {
                path: faqPagePath,
                element: <FaqPage />,
              },
              {
                path: languagePagePath,
                element: <LanguagePage />,
              },
            ],
          },
          {
            path: versionPagePath,
            element: <VersionPage />,
          },
          {
            path: '*',
            element: <NotFoundPage />,
          },
        ],
      },
    ],
    { basename: basePath },
  )
